<template>
    <div class="solution-item">
        <div class="container">
            <div class="row">
                <div class="col-md-7 solution-content">
                    <h1 class="number">
                        <span>{{ number }}.&nbsp;</span>
                    </h1>
                    <h3>{{ data.title }}</h3>
                    <div v-html="data.description"></div>
                </div>
            </div>
        </div>
        <div class="solution-feature" v-if="data.imageArea.type.length > 0">
            <div class="row">
                <div class="col-md-9">
                    <!-- Trocar por divs com imagens de fundo -->
                    <img :src="data.imageArea.src" class="img-fluid" v-if="data.imageArea.type === 'image'">

                    <div class="row solution-gallery" v-if="data.imageArea.type === 'gallery'">
                        <div class="col-md-3" v-for="image of data.imageArea.images">
                            <a href="#" data-toggle="modal" :data-target="'#exampleModal' + number" v-on:click="openImgModal(image.src)">
                                <div class="image-hover">
                                    <div class="image-hover-content">
                                        <i class="fas fa-expand"></i>
                                    </div>
                                </div>
                                <img :src="image.src" class="img-fluid">
                            </a>
                        </div>
                    </div>
                </div>
                <div v-if="hasTopics()" class="topics col-md-3">
                    <ul>
                        <li v-for="item in data.topics">{{ item.title }}</li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="solution-feature-mobile">
            <!-- Trocar por div com imagens de fundo -->
            <img :src="data.imageArea.src" class="img-fluid" v-if="data.imageArea.type === 'image'">

            <div v-if="hasTopics()" class="container">
                <ul>
                    <li v-for="item in data.topics"> {{ item.title }}</li>
                </ul>
            </div>

            <div class="container" v-if="data.imageArea.type === 'gallery'">
                <div class="row solution-gallery">
                    <div class="col-4" v-for="image of data.imageArea.images">
                        <a href="#" data-toggle="modal" :data-target="'#exampleModal' + number" v-on:click="openImgModal(image.src)">
                            <div class="image-hover">
                                <div class="image-hover-content">
                                    <i class="fas fa-expand"></i>
                                </div>
                            </div>
                            <img :src="image.src" class="img-fluid">
                        </a>
                    </div>
                </div>
            </div>

        </div>
        <!-- Modal -->
        <div class="modal fade" :id="'exampleModal' + number" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="data.imageArea.type === 'gallery'">
            <div class="close-modal" data-dismiss="modal">
                <div class="lr">
                    <div class="rl"></div>
                </div>
            </div>
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <div :id="'carouselGallery' + number" class="carousel slide" data-ride="carousel" data-interval="false">
                            <div class="carousel-inner">
                                <div class="carousel-item" v-for="image of data.imageArea.images" :class="{ active: (image.src === srcImgModal) }">
                                    <img :src="image.src" class="img-fluid">
                                    <p class="carousel-gallery-caption">{{ image.caption }}</p>
                                </div>
                            </div>
                            <a class="carousel-control-prev" :href="'#carouselGallery' + number" role="button" data-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="sr-only">Previous</span>
                            </a>
                            <a class="carousel-control-next" :href="'#carouselGallery' + number" role="button" data-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="sr-only">Next</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['data', 'number'],
        mounted() {
            if (this.$props.data.imageArea.type === 'gallery') {
                const vue = this;               
                $(`#exampleModal${this.$props.number}`).on('hidden.bs.modal', function () {
                    vue.srcImgModal = '';                    
                });
            }
        },
        destroyed() {
            if (this.$props.data.imageArea.type === 'gallery') {
                $(`#exampleModal${this.$props.number}`).off('hidden.bs.modal');
            }
        },
        data() {
            return {
                srcImgModal: ''
            }
        },
        methods: {
            hasTopics() {
                return this.$props.data.topics ? true : false;
            },
            openImgModal(src) {
                $(`#carouselGallery${this.number} .carousel-inner > .carousel-item`).each((i, e) => {
                    e.classList.remove('active');
                })
                this.srcImgModal = src;
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/Item.solution.vue